import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { DndDropEvent, DropEffect } from 'ngx-drag-drop';
import { forkJoin } from 'rxjs';
import { KanbanService } from '../../core/services/kanban/kanban.service';
import { CallCenterService } from '../../core/services/call-center/call-center.service';
import { VisitaService } from '../../core/services/visitas/visita.service';
import { CallCenterLigacaoAnalitica } from '../../core/models/call-center/call-center-ligacao-analitica';
import { CallCenterTipo } from '../../core/models/call-center/call-center-tipo';
import { Visita } from '../../core/models/visitas/visita';
import {
  KanbanBoard,
  KanbanClienteBusca,
  KanbanDepartamento,
  KanbanDetalhe,
  KanbanEtapa,
  KanbanFormularioCampo,
  KanbanFormularioTipo,
  KanbanMotivoPerda,
  KanbanNegocio,
  KanbanArquivo,
  KanbanImportResult,
  KanbanProdutoBusca,
  KanbanSeller
} from '../../core/models/kanban/kanban';

@Component({
  standalone: false,
  selector: 'app-kanban',
  templateUrl: './kanban.component.html',
  styleUrls: ['./kanban.component.css'],
  preserveWhitespaces: false
})
export class KanbanComponent implements OnInit {
  @ViewChild('kanbanBoard', { static: false }) kanbanBoard: ElementRef<HTMLDivElement>;

  board: KanbanBoard = { departamentos: [], tags: [], formularios: [], formulario_campos: [], formulario_opcoes: [] };
  boardCompleto: KanbanBoard = { departamentos: [], tags: [], formularios: [], formulario_campos: [], formulario_opcoes: [] };
  departamentoSelecionado: KanbanDepartamento = null;
  detalhe: KanbanDetalhe = null;
  carregandoDetalhe = false;
  private detalheRequisicao = 0;
  private detalheEstadoSalvo = '';
  private clienteDetalheSalvando = 0;

  get cardsEtapaDetalhe(): KanbanNegocio[] {
    const negocio = this.detalhe?.negocio;
    if (!negocio) return [];
    const departamento = this.board.departamentos.find(d => d.id === negocio.departamento_id);
    return departamento?.etapas.find(e => e.id === negocio.etapa_id)?.negocios || [];
  }

  get indiceCardDetalhe(): number {
    return this.cardsEtapaDetalhe.findIndex(n => n.id === this.detalhe?.negocio?.id);
  }

  navegarCardEtapa(direcao: number) {
    if (this.carregandoDetalhe || this.indiceCardDetalhe < 0) return;
    const destino = this.cardsEtapaDetalhe[this.indiceCardDetalhe + direcao];
    if (!destino) return;
    if (this.clienteDetalheSaveTimer || this.clienteDetalheSalvando) {
      this.toastr.info('', 'Aguarde o salvamento do cliente antes de trocar de card.');
      return;
    }
    if (this.estadoEdicaoDetalhe() !== this.detalheEstadoSalvo || this.novaAnotacao?.trim() || this.anotacaoEditandoId != null) {
      this.toastr.warning('', 'Salve as alterações ou conclua a anotação antes de trocar de card.');
      return;
    }
    this.abrirDetalhe(destino);
  }

  private estadoEdicaoDetalhe(): string {
    return JSON.stringify([this.nomeNegocioEdicao, this.valorNegocioEdicao, this.dataFechamentoEdicao,
      this.canalOrigemEdicao, this.sellerResponsavelEdicao, this.formularioValoresDetalhe]);
  }
  clientes: KanbanClienteBusca[] = [];
  sellers: KanbanSeller[] = [];
  motivosPerda: KanbanMotivoPerda[] = [];

  carregando: boolean = false;
  novoAberto: boolean = false;
  perdaAberta: boolean = false;
  clienteBuscaAberta: boolean = false;
  buscaCliente: string = '';
  filtroClienteKanban: string = '';
  filtroClienteIdKanban: number = null;
  filtroIdKanban: string = '';
  filtroFormularioKanban: number = null;
  filtroSellerKanban: number = null;
  filtroFechamentoKanban: string = '';
  sellersFiltroKanban: KanbanSeller[] = [];
  clienteDetalheBuscaAberta: boolean = false;
  buscaClienteDetalhe: string = '';
  novaAnotacao: string = '';
  nomeNegocioEdicao: string = '';
  valorNegocioEdicao: number = null;
  dataFechamentoEdicao: string = '';
  canalOrigemEdicao: string = '';
  sellerResponsavelEdicao: number = null;
  sellersDetalhe: KanbanSeller[] = [];
  anotacaoEditandoId: number = null;
  anotacaoEditandoTexto: string = '';
  formularioValoresNovo: any = {};
  formularioValoresDetalhe: any = {};
  arquivosPendentesNovo: any = {};
  buscaProdutoNovo: any = {};
  buscaProdutoDetalhe: any = {};
  produtosNovo: any = {};
  produtosDetalhe: any = {};
  produtoSelecionadoNovo: any = {};
  produtoSelecionadoDetalhe: any = {};
  usaKanban: boolean = false;
  importacaoAberta: boolean = false;
  importando: boolean = false;
  importacao: any = {};
  arquivoImportacao: File = null;
  resultadoImportacao: KanbanImportResult = null;

  novo: any = {};
  clienteDetalheEdicao: any = {};
  perda: any = {};
  ganhoEtapaAberta: boolean = false;
  etapaGanhoSelecionadaId: number = null;
  negocioArrastandoId: number = null;
  boardArrastando: boolean = false;
  cardsVisiveisPorEtapa: any = {};
  readonly cardsPorPagina: number = 20;
  private clienteDetalheSaveTimer: any = null;
  private boardDragStartX: number = 0;
  private boardDragScrollLeft: number = 0;

  constructor(
    private kanbanService: KanbanService,
    private callCenterService: CallCenterService,
    private visitaService: VisitaService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.usaKanban = localStorage.getItem('usa_kanban') === 'true';

    if (!this.usaKanban) {
      return;
    }

    this.route.queryParams.subscribe(params => {
      const clienteId = params['cliente_id'];
      this.filtroClienteIdKanban = clienteId != null && !isNaN(parseInt(clienteId, 10)) ? parseInt(clienteId, 10) : null;
      this.carregar();
    });
  }

  iniciarArrasteBoard(evento: MouseEvent) {
    if (!this.kanbanBoard || this.deveIgnorarArrasteBoard(evento.target as HTMLElement)) {
      return;
    }

    this.boardArrastando = true;
    this.boardDragStartX = evento.pageX - this.kanbanBoard.nativeElement.offsetLeft;
    this.boardDragScrollLeft = this.kanbanBoard.nativeElement.scrollLeft;
  }

  moverArrasteBoard(evento: MouseEvent) {
    if (!this.boardArrastando || !this.kanbanBoard) {
      return;
    }

    evento.preventDefault();
    const x = evento.pageX - this.kanbanBoard.nativeElement.offsetLeft;
    const deslocamento = x - this.boardDragStartX;
    this.kanbanBoard.nativeElement.scrollLeft = this.boardDragScrollLeft - deslocamento;
  }

  finalizarArrasteBoard() {
    this.boardArrastando = false;
  }

  private deveIgnorarArrasteBoard(elemento: HTMLElement): boolean {
    if (!elemento) {
      return true;
    }

    return !!elemento.closest('.deal-card, button, input, select, textarea, a, .kanban-modal, .side-panel');
  }

  carregar() {
    this.carregando = true;

    this.kanbanService.getBoard().subscribe(board => {
      this.boardCompleto = board || { departamentos: [], tags: [], formularios: [], formulario_campos: [], formulario_opcoes: [] };
      this.boardCompleto.formularios = this.boardCompleto.formularios || [];
      this.boardCompleto.formulario_campos = this.boardCompleto.formulario_campos || [];
      this.boardCompleto.formulario_opcoes = this.boardCompleto.formulario_opcoes || [];
      this.prepararOpcoesFormularioBoard();
      this.sellersFiltroKanban = this.extrairSellersDoBoard(this.boardCompleto);
      this.aplicarFiltroCliente(false);

      if (!this.departamentoSelecionado && this.board.departamentos.length > 0) {
        this.departamentoSelecionado = this.board.departamentos[0];
      } else if (this.departamentoSelecionado) {
        this.departamentoSelecionado = this.board.departamentos.find(d => d.id === this.departamentoSelecionado.id) || this.board.departamentos[0];
      }

      this.carregando = false;
    });
  }

  abrirDashboard() {
    this.router.navigate(['/kanban-dashboard']);
  }

  aplicarFiltroCliente(limparId: boolean = true) {
    if (limparId) {
      this.filtroClienteIdKanban = null;
    }

    this.reiniciarLimitesEtapas();

    const termo = this.normalizarFiltro(this.filtroClienteKanban);
    const clienteId = this.filtroClienteIdKanban;
    const negocioId = this.filtroIdKanban ? Number(this.filtroIdKanban) : null;
    const formularioId = this.filtroFormularioKanban ? Number(this.filtroFormularioKanban) : null;
    const sellerId = this.filtroSellerKanban ? Number(this.filtroSellerKanban) : null;
    const filtroFechamento = this.filtroFechamentoKanban;

    if (!termo && !clienteId && !negocioId && !formularioId && !sellerId && !filtroFechamento) {
      this.board = this.clonarBoard(this.boardCompleto);
      this.sincronizarDepartamentoSelecionado();
      return;
    }

    const boardFiltrado = this.clonarBoard(this.boardCompleto);

    boardFiltrado.departamentos.forEach(departamento => {
      departamento.etapas.forEach(etapa => {
        etapa.negocios = etapa.negocios.filter(negocio => {
          if (clienteId && negocio.client_id !== clienteId) {
            return false;
          }

          if (negocioId && negocio.id !== negocioId) {
            return false;
          }

          if (formularioId && negocio.formulario_tipo_id !== formularioId) {
            return false;
          }

          if (sellerId && negocio.seller_id_responsavel !== sellerId) {
            return false;
          }

          if (filtroFechamento && !this.negocioPassaFiltroFechamento(negocio, filtroFechamento)) {
            return false;
          }

          if (!termo) {
            return true;
          }

          return this.normalizarFiltro(negocio.cliente_nome).indexOf(termo) >= 0
            || this.normalizarFiltro(negocio.cliente_fantasia).indexOf(termo) >= 0
            || this.normalizarFiltro(negocio.codigo_no_erp_do_cliente).indexOf(termo) >= 0
            || this.normalizarFiltro(negocio.nome_negocio).indexOf(termo) >= 0;
        });
      });
    });

    this.board = boardFiltrado;
    this.sincronizarDepartamentoSelecionado();
  }

  negociosVisiveis(etapa: KanbanEtapa): KanbanNegocio[] {
    if (!etapa || !etapa.negocios) {
      return [];
    }

    return etapa.negocios.slice(0, this.limiteCardsEtapa(etapa));
  }

  temMaisCards(etapa: KanbanEtapa): boolean {
    return !!etapa && !!etapa.negocios && etapa.negocios.length > this.limiteCardsEtapa(etapa);
  }

  carregarMaisCards(etapa: KanbanEtapa, evento?: Event) {
    if (evento) {
      evento.stopPropagation();
    }

    if (!etapa) {
      return;
    }

    this.cardsVisiveisPorEtapa[etapa.id] = this.limiteCardsEtapa(etapa) + this.cardsPorPagina;
  }

  private limiteCardsEtapa(etapa: KanbanEtapa): number {
    return this.cardsVisiveisPorEtapa[etapa.id] || this.cardsPorPagina;
  }

  private reiniciarLimitesEtapas() {
    this.cardsVisiveisPorEtapa = {};
  }

  limparFiltroCliente() {
    this.filtroClienteKanban = '';
    this.filtroClienteIdKanban = null;
    this.filtroIdKanban = '';
    this.filtroFormularioKanban = null;
    this.filtroSellerKanban = null;
    this.filtroFechamentoKanban = '';
    this.aplicarFiltroCliente(false);
  }

  private clonarBoard(board: KanbanBoard): KanbanBoard {
    return JSON.parse(JSON.stringify(board || { departamentos: [], tags: [], formularios: [], formulario_campos: [], formulario_opcoes: [] }));
  }

  private normalizarFiltro(valor: string): string {
    return (valor || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }

  private extrairSellersDoBoard(board: KanbanBoard): KanbanSeller[] {
    const mapa: any = {};

    (board.departamentos || []).forEach(departamento => {
      (departamento.etapas || []).forEach(etapa => {
        (etapa.negocios || []).forEach(negocio => {
          if (negocio.seller_id_responsavel && !mapa[negocio.seller_id_responsavel]) {
            mapa[negocio.seller_id_responsavel] = {
              id: negocio.seller_id_responsavel,
              fullname: negocio.seller_responsavel_nome || ('Seller ' + negocio.seller_id_responsavel)
            };
          }
        });
      });
    });

    return Object.keys(mapa)
      .map(id => mapa[id])
      .sort((a, b) => (a.fullname || '').localeCompare(b.fullname || ''));
  }

  private negocioPassaFiltroFechamento(negocio: KanbanNegocio, filtro: string): boolean {
    const fechamento = this.dataSemHora(negocio.data_fechamento_prevista);

    if (!fechamento) {
      return false;
    }

    const hoje = this.dataSemHora(new Date());
    const limite7 = new Date(hoje.getTime());
    limite7.setDate(limite7.getDate() + 7);

    if (filtro === 'ATRASADA') {
      return fechamento < hoje;
    }

    if (filtro === 'HOJE') {
      return fechamento.getTime() === hoje.getTime();
    }

    if (filtro === 'FUTURA_7') {
      return fechamento > hoje && fechamento <= limite7;
    }

    if (filtro === 'FUTURA_MAIS_7') {
      return fechamento > limite7;
    }

    return true;
  }

  private dataSemHora(valor: any): Date {
    if (!valor) {
      return null;
    }

    const data = valor instanceof Date ? valor : new Date(valor);

    if (isNaN(data.getTime())) {
      return null;
    }

    return new Date(data.getFullYear(), data.getMonth(), data.getDate());
  }

  private sincronizarDepartamentoSelecionado() {
    if (!this.board || this.board.departamentos.length === 0) {
      this.departamentoSelecionado = null;
      return;
    }

    if (this.departamentoSelecionado) {
      this.departamentoSelecionado = this.board.departamentos.find(d => d.id === this.departamentoSelecionado.id) || this.board.departamentos[0];
      return;
    }

    this.departamentoSelecionado = this.board.departamentos[0];
  }

  selecionarDepartamento(departamento: KanbanDepartamento) {
    this.departamentoSelecionado = departamento;

    if (this.filtroFormularioKanban && !this.formulariosDoDepartamento().some(formulario => formulario.id === Number(this.filtroFormularioKanban))) {
      this.filtroFormularioKanban = null;
    }

    this.aplicarFiltroCliente(false);
  }

  formulariosDoDepartamento(departamentoId?: number): KanbanFormularioTipo[] {
    const id = departamentoId || (this.departamentoSelecionado ? this.departamentoSelecionado.id : 0);
    return (this.boardCompleto.formularios || []).filter(f => f.departamento_id === id && f.ativo !== false);
  }

  camposDoFormulario(formularioTipoId: number): KanbanFormularioCampo[] {
    return (this.boardCompleto.formulario_campos || [])
      .filter(c => c.formulario_tipo_id === formularioTipoId && c.ativo !== false)
      .sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
  }

  camposNovo(): KanbanFormularioCampo[] {
    return this.camposDoFormulario(this.novo ? Number(this.novo.formulario_tipo_id) : 0);
  }

  etapasImportacao(): KanbanEtapa[] {
    return this.departamentoSelecionado && this.departamentoSelecionado.etapas
      ? this.departamentoSelecionado.etapas.filter(etapa => etapa.ativo !== false)
      : [];
  }

  formularioNome(formularioTipoId: number, departamentoId?: number): string {
    const formulario = this.formulariosDoDepartamento(departamentoId).find(f => f.id === Number(formularioTipoId));
    return formulario ? formulario.nome : '';
  }

  camposDetalhe(): KanbanFormularioCampo[] {
    if (!this.detalhe || !this.detalhe.negocio) {
      return [];
    }

    return (this.detalhe.formulario_campos || []).sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
  }

  prepararOpcoesFormularioBoard() {
    (this.boardCompleto.formulario_campos || []).forEach(campo => {
      campo.opcoes = (this.boardCompleto.formulario_opcoes || []).filter(opcao => opcao.campo_id === campo.id);
    });
  }

  selecionarFormularioNovo() {
    this.formularioValoresNovo = {};
    this.arquivosPendentesNovo = {};
    this.limparBuscaProdutosNovo();
    this.sincronizarCamposPadraoNovo();
  }

  private prepararFormularioNovo() {
    const formularios = this.formulariosDoDepartamento(this.novo.departamento_id);
    this.novo.formulario_tipo_id = formularios.length === 1 ? formularios[0].id : null;
    this.formularioValoresNovo = {};
    this.arquivosPendentesNovo = {};
    this.limparBuscaProdutosNovo();
    this.sincronizarCamposPadraoNovo();
  }

  private limparBuscaProdutosNovo() {
    this.buscaProdutoNovo = {};
    this.produtosNovo = {};
    this.produtoSelecionadoNovo = {};
  }

  private sincronizarCamposPadraoNovo() {
    this.camposNovo().forEach(campo => {
      if (this.formularioValoresNovo[campo.id] != null) {
        return;
      }

      if (campo.chave === 'nome_negocio') {
        this.formularioValoresNovo[campo.id] = this.novo.nome_negocio || '';
      } else if (campo.chave === 'client_id') {
        this.formularioValoresNovo[campo.id] = this.novo.client_id || null;
      } else if (campo.chave === 'data_fechamento_prevista') {
        const dataPredefinida = this.calcularDataPredefinida(campo.valor_padrao);
        this.formularioValoresNovo[campo.id] = dataPredefinida;
        this.novo.data_fechamento_prevista = dataPredefinida;
      } else if (campo.chave === 'seller_id_responsavel') {
        this.formularioValoresNovo[campo.id] = this.novo.seller_id_responsavel || null;
      } else if (campo.chave === 'valor_negociacao') {
        this.formularioValoresNovo[campo.id] = this.novo.valor_negociacao || null;
      } else if (campo.chave === 'canal_origem') {
        this.formularioValoresNovo[campo.id] = this.novo.canal_origem || '';
      } else if (campo.valor_padrao) {
        this.formularioValoresNovo[campo.id] = campo.valor_padrao;
      }
    });
  }

  private calcularDataPredefinida(valorPadrao: any): string {
    if (valorPadrao === null || valorPadrao === undefined || valorPadrao === '') {
      return null;
    }

    const dias = Number(valorPadrao);

    if (isNaN(dias)) {
      return null;
    }

    const data = new Date();
    data.setDate(data.getDate() + dias);
    return this.formatarDataInput(data);
  }

  private aplicarCampoPadraoNovo(campo: KanbanFormularioCampo) {
    const valor = this.formularioValoresNovo[campo.id];

    if (campo.chave === 'nome_negocio') {
      this.novo.nome_negocio = valor;
    } else if (campo.chave === 'client_id') {
      this.novo.client_id = valor;
    } else if (campo.chave === 'data_fechamento_prevista') {
      this.novo.data_fechamento_prevista = valor;
    } else if (campo.chave === 'seller_id_responsavel') {
      this.novo.seller_id_responsavel = Number(valor);
    } else if (campo.chave === 'valor_negociacao') {
      this.novo.valor_negociacao = valor;
    } else if (campo.chave === 'canal_origem') {
      this.novo.canal_origem = valor;
    }
  }

  private atualizarCampoFormularioNovo(chave: string, valor: any) {
    this.camposNovo()
      .filter(campo => campo.chave === chave)
      .forEach(campo => this.formularioValoresNovo[campo.id] = valor);
  }

  campoFormularioAlterado(campo: KanbanFormularioCampo) {
    if (!campo) {
      return;
    }

    this.aplicarCampoPadraoNovo(campo);
  }

  campoDetalheAlterado(campo: KanbanFormularioCampo) {
    if (!campo) {
      return;
    }

    const valor = this.formularioValoresDetalhe[campo.id];
    if (campo.chave === 'nome_negocio') {
      this.nomeNegocioEdicao = valor;
    } else if (campo.chave === 'data_fechamento_prevista') {
      this.dataFechamentoEdicao = valor;
    } else if (campo.chave === 'seller_id_responsavel') {
      this.sellerResponsavelEdicao = Number(valor);
    } else if (campo.chave === 'valor_negociacao') {
      this.valorNegocioEdicao = valor;
    } else if (campo.chave === 'canal_origem') {
      this.canalOrigemEdicao = valor;
    }
  }

  private montarValoresFormulario(campos: KanbanFormularioCampo[], mapa: any): any[] {
    return (campos || []).map(campo => {
      const valor = mapa[campo.id];
      const item: any = { campo_id: campo.id };

      if (campo.tipo === 'DECIMAL') {
        item.valor_decimal = valor === '' || valor == null ? null : Number(valor);
      } else if (campo.tipo === 'INTEIRO') {
        item.valor_inteiro = valor === '' || valor == null ? null : Number(valor);
      } else if (campo.tipo === 'PRODUTO') {
        item.valor_inteiro = valor === '' || valor == null ? null : Number(valor);
      } else if (campo.tipo === 'DATA') {
        item.valor_data = valor || null;
      } else if (campo.tipo === 'CADASTRO' || campo.chave === 'client_id') {
        item.valor_client_id = valor || null;
      } else if (campo.tipo === 'ARQUIVO') {
        item.valor_arquivo_id = valor || null;
      } else if (campo.tipo === 'ALTERNATIVA') {
        item.valor_opcao_id = valor || null;
      } else {
        item.valor_texto = valor == null ? null : valor.toString();
      }

      return item;
    });
  }

  private campoObrigatorioVazio(campo: KanbanFormularioCampo, mapa: any, arquivosPendentes?: any): boolean {
    const valor = mapa[campo.id];

    if (campo.tipo === 'ARQUIVO') {
      return !valor && !(arquivosPendentes && arquivosPendentes[campo.id]);
    }

    return valor == null || valor === '';
  }

  bloquearEdicaoVendedorResponsavel(): boolean {
    const isMasterSeller = localStorage.getItem('is_master_seller') === 'true';
    const isMaster = localStorage.getItem('is_master') === 'true';
    const isManager = localStorage.getItem('is_manager') === 'true';
    const isDiretor = localStorage.getItem('is_diretor') === 'true';
    const isFinanceiro = localStorage.getItem('is_financeiro') === 'true';
    const vendedorExterno = !isMaster && !isManager && !isMasterSeller && !isDiretor && !isFinanceiro;

    return isMasterSeller || vendedorExterno;
  }

  diasAberto(negocio: KanbanNegocio): number {
    if (!negocio || !negocio.data_criacao) {
      return 0;
    }

    const criadoEm = new Date(negocio.data_criacao).getTime();

    if (isNaN(criadoEm)) {
      return 0;
    }

    const diff = new Date().getTime() - criadoEm;
    return Math.max(0, Math.floor(diff / (1000 * 60 * 60 * 24)));
  }

  textoTempoAberto(negocio: KanbanNegocio): string {
    const dias = this.diasAberto(negocio);
    return dias === 1 ? 'Aberto à 1 dia' : 'Aberto à ' + dias + ' dias';
  }

  classeTempoAberto(negocio: KanbanNegocio): string {
    const dias = this.diasAberto(negocio);

    if (dias > 4) {
      return 'deal-age-danger';
    }

    if (dias > 2) {
      return 'deal-age-warning';
    }

    return 'deal-age-ok';
  }

  diasAteFechamento(negocio: KanbanNegocio): number {
    if (!negocio || !negocio.data_fechamento_prevista) {
      return null;
    }

    const hoje = new Date();
    const fechamento = new Date(negocio.data_fechamento_prevista);

    if (isNaN(fechamento.getTime())) {
      return null;
    }

    hoje.setHours(0, 0, 0, 0);
    fechamento.setHours(0, 0, 0, 0);

    return Math.floor((fechamento.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24));
  }

  textoFechamento(negocio: KanbanNegocio): string {
    const dias = this.diasAteFechamento(negocio);

    if (dias == null) {
      return '';
    }

    if (dias < 0) {
      return '! Fechamento vencido';
    }

    if (dias === 0) {
      return 'Fecha hoje';
    }

    return dias === 1 ? 'Fecha em 1 dia' : 'Fecha em ' + dias + ' dias';
  }

  classeFechamento(negocio: KanbanNegocio): string {
    const dias = this.diasAteFechamento(negocio);

    if (dias == null) {
      return '';
    }

    if (dias < 0) {
      return 'deal-close-danger';
    }

    if (dias === 0) {
      return 'deal-close-warning';
    }

    return 'deal-close-ok';
  }

  abrirNovo() {
    this.novoAberto = true;
    this.detalhe = null;
    this.arquivosPendentesNovo = {};
    this.limparBuscaProdutosNovo();
    this.buscaCliente = '';
    this.clientes = [];
    this.clienteBuscaAberta = false;

    const etapa = this.primeiraEtapaAberta();
    this.novo = {
      nome_negocio: '',
      client_id: null,
      seller_id_responsavel: parseInt(localStorage.getItem('id'), 10),
      departamento_id: this.departamentoSelecionado ? this.departamentoSelecionado.id : null,
      etapa_id: etapa ? etapa.id : null,
      valor_negociacao: null,
      data_fechamento_prevista: null,
      canal_origem: ''
    };

    if (this.novo.departamento_id) {
      this.carregarSellers(this.novo.departamento_id);
    }

    this.prepararFormularioNovo();
  }

  abrirImportacao() {
    if (!this.departamentoSelecionado) {
      this.toastr.warning('', 'Selecione um departamento para importar os cards.');
      return;
    }

    const etapas = this.etapasImportacao();
    const formularios = this.formulariosDoDepartamento(this.departamentoSelecionado.id);

    this.importacao = {
      etapa_id: etapas.length ? etapas[0].id : null,
      formulario_tipo_id: formularios.length ? formularios[0].id : null
    };
    this.arquivoImportacao = null;
    this.resultadoImportacao = null;
    this.importacaoAberta = true;
  }

  fecharImportacao() {
    if (this.importando) {
      return;
    }

    this.importacaoAberta = false;
  }

  selecionarArquivoImportacao(event: any) {
    const files = event && event.target && event.target.files ? event.target.files : [];
    this.arquivoImportacao = files.length ? files[0] : null;
    this.resultadoImportacao = null;
  }

  baixarModeloImportacao() {
    const colunas = this.colunasModeloImportacao();
    const conteudo = '\uFEFF' + colunas.join(';') + '\r\n';
    const blob = new Blob([conteudo], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'modelo_importacao_kanban.csv';
    link.click();
    URL.revokeObjectURL(link.href);
  }

  colunasModeloImportacao(): string[] {
    const padrao = ['nome_negocio', 'coderpcli', 'data_fechamento_prevista'];
    const ignorar = new Set(['nome_negocio', 'coderpcli', 'client_id', 'data_fechamento_prevista', 'seller_id_responsavel']);
    const formularioId = this.importacao ? Number(this.importacao.formulario_tipo_id) : 0;
    const extras = this.camposDoFormulario(formularioId)
      .filter(campo => campo.chave && campo.tipo !== 'ARQUIVO' && !ignorar.has((campo.chave || '').toLowerCase()))
      .map(campo => campo.chave);

    return padrao.concat(extras);
  }

  importarCards() {
    if (!this.importacao || !this.importacao.etapa_id || !this.importacao.formulario_tipo_id) {
      this.toastr.warning('', 'Selecione a etapa e o formulario para importar.');
      return;
    }

    if (!this.arquivoImportacao) {
      this.toastr.warning('', 'Selecione a planilha para importar.');
      return;
    }

    this.importando = true;
    this.resultadoImportacao = null;

    this.kanbanService.importDeals(this.importacao.etapa_id, this.importacao.formulario_tipo_id, this.arquivoImportacao).subscribe(resultado => {
      this.importando = false;
      this.resultadoImportacao = resultado;

      if (resultado && resultado.importados > 0) {
        this.toastr.success('', `${resultado.importados} card(s) importado(s) com sucesso.`);
        this.carregar();
      }

      if (resultado && resultado.erros && resultado.erros.length > 0) {
        this.toastr.warning('', 'Importacao concluida com alertas. Verifique os detalhes no modal.');
        return;
      }

      if (resultado && resultado.importados > 0) {
        this.importacaoAberta = false;
      }
    });
  }

  podeInativarCard(): boolean {
    return localStorage.getItem('is_master') === 'true' || localStorage.getItem('is_diretor') === 'true';
  }

  inativarCard() {
    if (!this.detalhe || !this.detalhe.negocio || !this.podeInativarCard()) {
      return;
    }

    if (!window.confirm('Deseja inativar este card?')) {
      return;
    }

    this.kanbanService.inactivateDeal(this.detalhe.negocio.id).subscribe(ok => {
      if (ok) {
        this.toastr.success('', 'Card inativado com sucesso.');
        this.fecharDetalhe();
        this.carregar();
      } else {
        this.toastr.error('', 'Nao foi possivel inativar o card.');
      }
    });
  }

  fecharNovo() {
    this.novoAberto = false;
  }

  carregarSellers(departamentoId: number) {
    this.kanbanService.getSellers(departamentoId).subscribe(sellers => {
      this.sellers = sellers || [];
      this.definirSellerResponsavelPadrao(this.novo && this.novo.client_seller_id);
      this.atualizarCampoFormularioNovo('seller_id_responsavel', this.novo ? this.novo.seller_id_responsavel : null);
    });
  }

  buscarClientes() {
    const termo = (this.buscaCliente || '').trim();

    if (!termo || termo.length < 2) {
      this.clientes = [];
      this.toastr.warning('', 'Digite pelo menos 2 caracteres para buscar o cliente.');
      return;
    }

    this.kanbanService.searchClients(termo).subscribe(clientes => {
      this.clientes = clientes || [];
      this.clienteBuscaAberta = true;

      if (this.clientes.length === 0) {
        this.toastr.info('', 'Nenhum cliente localizado para a busca informada.');
      }
    });
  }

  fecharBuscaClientes() {
    this.clienteBuscaAberta = false;
  }

  selecionarCliente(cliente: KanbanClienteBusca) {
    this.novo.client_id = cliente.id;
    this.novo.cliente_nome = cliente.name;
    this.novo.responsible_name = cliente.responsible_name;
    this.novo.contato_callcenter = cliente.contato_callcenter;
    this.novo.phone = cliente.phone;
    this.novo.fone_02 = cliente.fone_02;
    this.novo.fone_03 = cliente.fone_03;
    this.novo.fone_whatss_ddd = cliente.fone_whatss_ddd;
    this.novo.fone_whatss = cliente.fone_whatss;
    this.novo.client_seller_id = cliente.seller_id;
    this.definirSellerResponsavelPadrao(cliente.seller_id);
    this.atualizarCampoFormularioNovo('client_id', this.novo.client_id);
    this.atualizarCampoFormularioNovo('seller_id_responsavel', this.novo.seller_id_responsavel);
    this.clientes = [];
    this.clienteBuscaAberta = false;
    this.buscaCliente = cliente.name;

    if (!this.novo.nome_negocio) {
      this.novo.nome_negocio = 'Negocio - ' + cliente.name;
      this.atualizarCampoFormularioNovo('nome_negocio', this.novo.nome_negocio);
    }
  }

  trocarClienteSelecionado() {
    this.novo.client_id = null;
    this.novo.cliente_nome = '';
    this.novo.responsible_name = '';
    this.novo.contato_callcenter = '';
    this.novo.phone = '';
    this.novo.fone_02 = '';
    this.novo.fone_03 = '';
    this.novo.fone_whatss_ddd = '';
    this.novo.fone_whatss = '';
    this.novo.client_seller_id = null;
    this.definirSellerResponsavelPadrao(null);
    this.atualizarCampoFormularioNovo('client_id', null);
    this.atualizarCampoFormularioNovo('seller_id_responsavel', this.novo.seller_id_responsavel);
    this.buscaCliente = '';
    this.clientes = [];
    this.clienteBuscaAberta = false;
  }

  buscarProdutosNovo(campo: KanbanFormularioCampo) {
    const termo = ((this.buscaProdutoNovo || {})[campo.id] || '').trim();

    if (!termo || termo.length < 2) {
      this.produtosNovo[campo.id] = [];
      this.toastr.warning('', 'Digite pelo menos 2 caracteres para buscar o produto.');
      return;
    }

    this.kanbanService.searchProducts(termo).subscribe(produtos => {
      this.produtosNovo[campo.id] = produtos || [];

      if (!this.produtosNovo[campo.id].length) {
        this.toastr.info('', 'Nenhum produto localizado para a busca informada.');
      }
    });
  }

  selecionarProdutoNovo(campo: KanbanFormularioCampo, produto: KanbanProdutoBusca) {
    this.formularioValoresNovo[campo.id] = produto.id;
    this.produtoSelecionadoNovo[campo.id] = produto;
    this.buscaProdutoNovo[campo.id] = this.textoProduto(produto);
    this.produtosNovo[campo.id] = [];
    this.campoFormularioAlterado(campo);
  }

  limparProdutoNovo(campo: KanbanFormularioCampo) {
    this.formularioValoresNovo[campo.id] = null;
    this.produtoSelecionadoNovo[campo.id] = null;
    this.buscaProdutoNovo[campo.id] = '';
    this.produtosNovo[campo.id] = [];
  }

  produtoSelecionadoTextoNovo(campo: KanbanFormularioCampo): string {
    return this.textoProduto(this.produtoSelecionadoNovo[campo.id]) || (this.formularioValoresNovo[campo.id] ? 'ID: ' + this.formularioValoresNovo[campo.id] : '');
  }

  definirSellerResponsavelPadrao(clientSellerId: number) {
    const usuarioLogado = parseInt(localStorage.getItem('id'), 10);
    const sellerCliente = clientSellerId ? Number(clientSellerId) : null;
    const sellerPermitido = sellerCliente && this.sellers.some(seller => seller.id === sellerCliente);

    this.novo.seller_id_responsavel = sellerPermitido ? sellerCliente : usuarioLogado;
  }

  criarCard() {
    const campos = this.camposNovo();
    campos.forEach(campo => this.aplicarCampoPadraoNovo(campo));

    if (!this.novo.formulario_tipo_id && this.formulariosDoDepartamento(this.novo.departamento_id).length > 1) {
      this.toastr.warning('', 'Selecione o tipo de formulario do card.');
      return;
    }

    const obrigatorioFaltando = campos.find(campo => campo.obrigatorio && this.campoObrigatorioVazio(campo, this.formularioValoresNovo, this.arquivosPendentesNovo));
    if (obrigatorioFaltando) {
      this.toastr.warning('', 'Preencha o campo obrigatorio: ' + obrigatorioFaltando.nome + '.');
      return;
    }

    if (!this.novo.nome_negocio || !this.novo.client_id || !this.novo.departamento_id || !this.novo.etapa_id || !this.novo.seller_id_responsavel) {
      this.toastr.warning('', 'Preencha nome do negocio, cliente, etapa e vendedor.');
      return;
    }

    this.novo.formulario_valores = this.novo.formulario_tipo_id ? this.montarValoresFormulario(campos, this.formularioValoresNovo) : [];

    this.kanbanService.createDeal(this.novo).subscribe(id => {
      if (id > 0) {
        this.salvarArquivosFormularioNovo(id, campos);
      }
    });
  }

  private salvarArquivosFormularioNovo(negocioId: number, campos: KanbanFormularioCampo[]) {
    const camposArquivo = (campos || []).filter(campo => campo.tipo === 'ARQUIVO' && this.arquivosPendentesNovo[campo.id]);

    if (camposArquivo.length === 0) {
      this.finalizarCriacaoCard();
      return;
    }

    this.enviarArquivoFormularioNovo(negocioId, campos, camposArquivo, 0);
  }

  private enviarArquivoFormularioNovo(negocioId: number, campos: KanbanFormularioCampo[], camposArquivo: KanbanFormularioCampo[], indice: number) {
    if (indice >= camposArquivo.length) {
      const payload = {
        negocio_id: negocioId,
        formulario_tipo_id: this.novo.formulario_tipo_id,
        valores: this.montarValoresFormulario(campos, this.formularioValoresNovo)
      };

      this.kanbanService.saveDealForm(payload).subscribe(ok => {
        if (!ok) {
          this.toastr.warning('', 'Card criado, mas nao foi possivel vincular todos os arquivos ao formulario.');
        }

        this.finalizarCriacaoCard();
      });
      return;
    }

    const campo = camposArquivo[indice];
    const arquivo = this.arquivosPendentesNovo[campo.id];

    this.kanbanService.uploadFile(negocioId, arquivo).subscribe(anexo => {
      if (anexo) {
        this.formularioValoresNovo[campo.id] = anexo.id;
      } else {
        this.toastr.warning('', 'Nao foi possivel anexar o arquivo do campo: ' + campo.nome + '.');
      }

      this.enviarArquivoFormularioNovo(negocioId, campos, camposArquivo, indice + 1);
    });
  }

  private finalizarCriacaoCard() {
    this.toastr.success('', 'Card criado com sucesso.');
    this.novoAberto = false;
    this.arquivosPendentesNovo = {};
    this.carregar();
  }

  abrirDetalhe(negocio: KanbanNegocio) {
    const requisicao = ++this.detalheRequisicao;
    this.carregandoDetalhe = true;
    this.novoAberto = false;
    this.perdaAberta = false;
    this.anotacaoEditandoId = null;
    this.kanbanService.getDeal(negocio.id).subscribe({
      next: detalhe => {
        if (requisicao !== this.detalheRequisicao) return;
        this.carregandoDetalhe = false;
        if (!detalhe?.negocio) {
          this.toastr.error('', 'Não foi possível carregar o card.');
          return;
        }
        this.detalhe = detalhe;
        this.clienteDetalheBuscaAberta = false;
        this.prepararEdicaoDetalhe();
        this.detalheEstadoSalvo = this.estadoEdicaoDetalhe();
      },
      error: () => {
        if (requisicao !== this.detalheRequisicao) return;
        this.carregandoDetalhe = false;
        this.toastr.error('', 'Não foi possível carregar o card.');
      }
    });
  }

  fecharDetalhe() {
    ++this.detalheRequisicao;
    this.carregandoDetalhe = false;
    this.detalhe = null;
    this.clienteDetalheBuscaAberta = false;
    this.limparAgendamentoClienteDetalhe();
  }

  mover(negocio: KanbanNegocio, etapaId: any) {
    const etapa = this.etapasDepartamento(negocio.departamento_id).find(e => e.id === parseInt(etapaId, 10));

    if (etapa && etapa.tipo === 'PERDA') {
      this.abrirPerdaParaNegocio(negocio, etapa.id);
      return;
    }

    this.kanbanService.moveDeal(negocio.id, parseInt(etapaId, 10)).subscribe(ok => {
      if (ok) {
        this.carregar();
      }
    });
  }

  onDragStart(evento: DndDropEvent, negocio: KanbanNegocio) {
    if (negocio) {
      this.negocioArrastandoId = negocio.id;
    }
  }

  onDragEnd(evento: DndDropEvent) {
    this.negocioArrastandoId = null;
  }

  onDragged(negocio: KanbanNegocio, negocios: KanbanNegocio[], effect: DropEffect) {
    if (effect === 'move' && negocios) {
      const index = negocios.indexOf(negocio);

      if (index > -1) {
        negocios.splice(index, 1);
      }
    }
  }

  onDrop(evento: DndDropEvent, etapaDestino: KanbanEtapa) {
    if (!evento || !evento.data || !etapaDestino) {
      return;
    }

    const negocio: KanbanNegocio = evento.data;

    if (negocio.etapa_id === etapaDestino.id) {
      this.carregar();
      return;
    }

    if (etapaDestino.tipo === 'PERDA') {
      this.carregar();
      this.abrirPerdaParaNegocio(negocio, etapaDestino.id);
      return;
    }

    this.kanbanService.moveDeal(negocio.id, etapaDestino.id).subscribe(ok => {
      if (ok) {
        this.toastr.success('', 'Card movido com sucesso.');
      } else {
        this.toastr.error('', 'Nao foi possivel mover o card.');
      }

      this.carregar();

      if (this.detalhe && this.detalhe.negocio && this.detalhe.negocio.id === negocio.id) {
        this.abrirDetalhe(negocio);
      }
    });
  }

  ganhar() {
    if (!this.detalhe || !this.detalhe.negocio) {
      return;
    }

    const etapasGanho = this.etapasFinalizacao('GANHO');
    if (etapasGanho.length === 0) {
      this.toastr.warning('', 'Nenhuma etapa de ganho configurada para este departamento.');
      return;
    }

    if (etapasGanho.length > 1) {
      this.etapaGanhoSelecionadaId = etapasGanho[0].id;
      this.ganhoEtapaAberta = true;
      return;
    }

    this.confirmarGanho(etapasGanho[0].id);
  }

  confirmarGanho(etapaId?: number) {
    if (!this.detalhe || !this.detalhe.negocio) {
      return;
    }

    const etapaFinalId = etapaId || this.etapaGanhoSelecionadaId;
    if (!etapaFinalId) {
      this.toastr.warning('', 'Selecione a etapa de ganho.');
      return;
    }

    this.kanbanService.finishDeal(this.detalhe.negocio.id, 'GANHO', null, null, etapaFinalId).subscribe(ok => {
      if (ok) {
        this.toastr.success('', 'Negocio marcado como ganho.');
        this.ganhoEtapaAberta = false;
        this.carregar();
        this.abrirDetalhe(this.detalhe.negocio);
      }
    });
  }

  fecharSelecaoGanho() {
    this.ganhoEtapaAberta = false;
    this.etapaGanhoSelecionadaId = null;
  }

  abrirPerda(etapaId?: number) {
    const etapasPerda = this.etapasFinalizacao('PERDA');
    this.perdaAberta = true;
    this.perda = {
      motivo_id: null,
      observacao: '',
      etapa_id: etapaId || (etapasPerda.length === 1 ? etapasPerda[0].id : null)
    };
    this.kanbanService.getLossReasons().subscribe(motivos => this.motivosPerda = motivos || []);
  }

  abrirPerdaParaNegocio(negocio: KanbanNegocio, etapaId?: number) {
    this.kanbanService.getDeal(negocio.id).subscribe(detalhe => {
      this.detalhe = detalhe;
      this.prepararEdicaoDetalhe();
      this.abrirPerda(etapaId);
      this.toastr.warning('', 'Informe o motivo da perda para concluir o card.');
    });
  }

  confirmarPerda() {
    if (!this.perda.motivo_id) {
      this.toastr.warning('', 'Selecione o motivo da perda.');
      return;
    }

    const etapasPerda = this.etapasFinalizacao('PERDA');
    if (etapasPerda.length > 1 && !this.perda.etapa_id) {
      this.toastr.warning('', 'Selecione a etapa de perda.');
      return;
    }

    const etapaPerdaId = this.perda.etapa_id || (etapasPerda.length === 1 ? etapasPerda[0].id : null);
    if (!etapaPerdaId) {
      this.toastr.warning('', 'Nenhuma etapa de perda configurada para este departamento.');
      return;
    }

    this.kanbanService.finishDeal(this.detalhe.negocio.id, 'PERDIDO', this.perda.motivo_id, this.perda.observacao, etapaPerdaId).subscribe(ok => {
      if (ok) {
        this.toastr.success('', 'Negocio marcado como perda.');
        this.perdaAberta = false;
        this.carregar();
        this.abrirDetalhe(this.detalhe.negocio);
      }
    });
  }

  adicionarAnotacao() {
    if (!this.novaAnotacao || !this.detalhe || !this.detalhe.negocio) {
      return;
    }

    this.kanbanService.addNote(this.detalhe.negocio.id, this.novaAnotacao).subscribe(ok => {
      if (ok) {
        this.novaAnotacao = '';
        this.abrirDetalhe(this.detalhe.negocio);
        this.carregar();
      }
    });
  }

  salvarNomeNegocio() {
    if (!this.detalhe || !this.detalhe.negocio || !this.nomeNegocioEdicao || !this.nomeNegocioEdicao.trim()) {
      this.toastr.warning('', 'Informe o nome do negocio.');
      return;
    }

    this.kanbanService.updateDealName(this.detalhe.negocio.id, this.nomeNegocioEdicao.trim()).subscribe(ok => {
      if (ok) {
        this.toastr.success('', 'Nome do negocio atualizado.');
        this.detalhe.negocio.nome_negocio = this.nomeNegocioEdicao.trim();
        this.carregar();
      }
    });
  }

  salvarInfoNegocio() {
    if (!this.detalhe || !this.detalhe.negocio) {
      return;
    }

    this.kanbanService.updateDealInfo(
      this.detalhe.negocio.id,
      this.valorNegocioEdicao,
      this.dataFechamentoEdicao,
      this.canalOrigemEdicao,
      this.sellerResponsavelEdicao
    ).subscribe(ok => {
      if (ok) {
        this.toastr.success('', 'Informacoes do negocio atualizadas.');
        this.detalhe.negocio.valor_negociacao = this.valorNegocioEdicao;
        this.detalhe.negocio.data_fechamento_prevista = this.dataFechamentoEdicao;
        this.detalhe.negocio.canal_origem = this.canalOrigemEdicao;
        this.detalhe.negocio.seller_id_responsavel = this.sellerResponsavelEdicao;

        const sellerSelecionado = this.sellersDetalhe.find(seller => seller.id === Number(this.sellerResponsavelEdicao));
        if (sellerSelecionado) {
          this.detalhe.negocio.seller_responsavel_nome = sellerSelecionado.fullname;
        }

        this.carregar();
      }
    });
  }

  salvarCardDetalhe() {
    if (!this.detalhe || !this.detalhe.negocio) {
      return;
    }

    if (this.detalhe.negocio.formulario_tipo_id) {
      this.salvarFormularioDetalhe();
      return;
    }

    if (!this.nomeNegocioEdicao || !this.nomeNegocioEdicao.trim()) {
      this.toastr.warning('', 'Informe o nome do negocio.');
      return;
    }

    const nomeNegocio = this.nomeNegocioEdicao.trim();

    forkJoin([
      this.kanbanService.updateDealName(this.detalhe.negocio.id, nomeNegocio),
      this.kanbanService.updateDealInfo(
        this.detalhe.negocio.id,
        this.valorNegocioEdicao,
        this.dataFechamentoEdicao,
        this.canalOrigemEdicao,
        this.sellerResponsavelEdicao
      )
    ]).subscribe(([nomeOk, infoOk]) => {
      if (nomeOk && infoOk) {
        this.toastr.success('', 'Card salvo com sucesso.');
        this.detalheEstadoSalvo = this.estadoEdicaoDetalhe();
        this.detalhe.negocio.nome_negocio = nomeNegocio;
        this.detalhe.negocio.valor_negociacao = this.valorNegocioEdicao;
        this.detalhe.negocio.data_fechamento_prevista = this.dataFechamentoEdicao;
        this.detalhe.negocio.canal_origem = this.canalOrigemEdicao;
        this.detalhe.negocio.seller_id_responsavel = this.sellerResponsavelEdicao;

        const sellerSelecionado = this.sellersDetalhe.find(seller => seller.id === Number(this.sellerResponsavelEdicao));
        if (sellerSelecionado) {
          this.detalhe.negocio.seller_responsavel_nome = sellerSelecionado.fullname;
        }

        this.carregar();
      } else {
        this.toastr.error('', 'Nao foi possivel salvar todas as alteracoes do card.');
      }
    });
  }

  salvarFormularioDetalhe() {
    if (!this.detalhe || !this.detalhe.negocio || !this.detalhe.negocio.formulario_tipo_id) {
      return;
    }

    this.camposDetalhe().forEach(campo => this.campoDetalheAlterado(campo));

    const obrigatorioFaltando = this.camposDetalhe().find(campo => campo.obrigatorio && this.campoObrigatorioVazio(campo, this.formularioValoresDetalhe));
    if (obrigatorioFaltando) {
      this.toastr.warning('', 'Preencha o campo obrigatorio: ' + obrigatorioFaltando.nome + '.');
      return;
    }

    const payload = {
      negocio_id: this.detalhe.negocio.id,
      formulario_tipo_id: this.detalhe.negocio.formulario_tipo_id,
      valores: this.montarValoresFormulario(this.camposDetalhe(), this.formularioValoresDetalhe)
    };

    this.kanbanService.saveDealForm(payload).subscribe(ok => {
      if (ok) {
        this.toastr.success('', 'Formulario do negocio salvo.');
        this.carregar();
        this.abrirDetalhe(this.detalhe.negocio);
      } else {
        this.toastr.error('', 'Nao foi possivel salvar o formulario do negocio.');
      }
    });
  }

  buscarClientesDetalhe() {
    const termo = (this.buscaClienteDetalhe || '').trim();

    if (!termo || termo.length < 2) {
      this.clientes = [];
      this.toastr.warning('', 'Digite pelo menos 2 caracteres para buscar o cliente.');
      return;
    }

    this.kanbanService.searchClients(termo).subscribe(clientes => {
      this.clientes = clientes || [];
      this.clienteDetalheBuscaAberta = true;

      if (this.clientes.length === 0) {
        this.toastr.info('', 'Nenhum cliente localizado para a busca informada.');
      }
    });
  }

  fecharBuscaClientesDetalhe() {
    this.clienteDetalheBuscaAberta = false;
  }

  selecionarClienteDetalhe(cliente: KanbanClienteBusca) {
    this.clienteDetalheEdicao = this.criarClienteEdicao(cliente);
    this.buscaClienteDetalhe = cliente.name;
    this.clienteDetalheBuscaAberta = false;
    this.clientes = [];
    this.camposDetalhe()
      .filter(campo => campo.chave === 'client_id')
      .forEach(campo => this.formularioValoresDetalhe[campo.id] = cliente.id);
    this.salvarClienteDetalhe(true, true);
  }

  buscarProdutosDetalhe(campo: KanbanFormularioCampo) {
    const termo = ((this.buscaProdutoDetalhe || {})[campo.id] || '').trim();

    if (!termo || termo.length < 2) {
      this.produtosDetalhe[campo.id] = [];
      this.toastr.warning('', 'Digite pelo menos 2 caracteres para buscar o produto.');
      return;
    }

    this.kanbanService.searchProducts(termo).subscribe(produtos => {
      this.produtosDetalhe[campo.id] = produtos || [];

      if (!this.produtosDetalhe[campo.id].length) {
        this.toastr.info('', 'Nenhum produto localizado para a busca informada.');
      }
    });
  }

  selecionarProdutoDetalhe(campo: KanbanFormularioCampo, produto: KanbanProdutoBusca) {
    this.formularioValoresDetalhe[campo.id] = produto.id;
    this.produtoSelecionadoDetalhe[campo.id] = produto;
    this.buscaProdutoDetalhe[campo.id] = this.textoProduto(produto);
    this.produtosDetalhe[campo.id] = [];
    this.campoDetalheAlterado(campo);
  }

  limparProdutoDetalhe(campo: KanbanFormularioCampo) {
    this.formularioValoresDetalhe[campo.id] = null;
    this.produtoSelecionadoDetalhe[campo.id] = null;
    this.buscaProdutoDetalhe[campo.id] = '';
    this.produtosDetalhe[campo.id] = [];
  }

  produtoSelecionadoTextoDetalhe(campo: KanbanFormularioCampo): string {
    return this.textoProduto(this.produtoSelecionadoDetalhe[campo.id]) || (this.formularioValoresDetalhe[campo.id] ? 'ID: ' + this.formularioValoresDetalhe[campo.id] : '');
  }

  private carregarProdutosSelecionadosDetalhe() {
    (this.detalhe.formulario_campos || [])
      .filter(campo => campo.tipo === 'PRODUTO' && this.formularioValoresDetalhe[campo.id])
      .forEach(campo => {
        this.kanbanService.searchProducts(String(this.formularioValoresDetalhe[campo.id])).subscribe(produtos => {
          const produto = (produtos || []).find(item => item.id === Number(this.formularioValoresDetalhe[campo.id]));

          if (produto) {
            this.produtoSelecionadoDetalhe[campo.id] = produto;
            this.buscaProdutoDetalhe[campo.id] = this.textoProduto(produto);
          }
        });
      });
  }

  private textoProduto(produto: KanbanProdutoBusca): string {
    if (!produto) {
      return '';
    }

    return (produto.id_no_erp_do_cliente ? 'COD ERP: ' + produto.id_no_erp_do_cliente + ' - ' : '') + produto.name;
  }

  agendarSalvarClienteDetalhe() {
    this.limparAgendamentoClienteDetalhe();
    this.clienteDetalheSaveTimer = setTimeout(() => {
      this.clienteDetalheSaveTimer = null;
      this.salvarClienteDetalhe(false, false);
    }, 800);
  }

  salvarClienteDetalhe(exibirSucesso: boolean = true, recarregarDetalhe: boolean = true) {
    if (!this.detalhe || !this.detalhe.negocio || !this.clienteDetalheEdicao || !this.clienteDetalheEdicao.client_id) {
      if (exibirSucesso) {
        this.toastr.warning('', 'Selecione um cliente para salvar.');
      }
      return;
    }

    const negocioAtual = this.detalhe.negocio;

    this.clienteDetalheSalvando++;
    this.kanbanService.updateDealClient(negocioAtual.id, this.clienteDetalheEdicao).subscribe(ok => {
      this.clienteDetalheSalvando--;
      if (this.detalhe?.negocio?.id !== negocioAtual.id) return;
      if (ok) {
        if (exibirSucesso) {
          this.toastr.success('', 'Cliente do negocio atualizado.');
        }

        this.atualizarClienteDetalheLocal();
        this.carregar();

        if (recarregarDetalhe) {
          this.abrirDetalhe(negocioAtual);
        }
      } else {
        this.toastr.error('', 'Nao foi possivel atualizar o cliente do negocio.');
      }
    });
  }

  private prepararEdicaoDetalhe() {
    if (!this.detalhe || !this.detalhe.negocio) {
      this.nomeNegocioEdicao = '';
      this.valorNegocioEdicao = null;
      this.dataFechamentoEdicao = '';
      this.canalOrigemEdicao = '';
      this.sellerResponsavelEdicao = null;
      this.sellersDetalhe = [];
      this.buscaClienteDetalhe = '';
      this.clienteDetalheEdicao = {};
      this.formularioValoresDetalhe = {};
      this.limparAgendamentoClienteDetalhe();
      return;
    }

    this.nomeNegocioEdicao = this.detalhe.negocio.nome_negocio || '';
    this.valorNegocioEdicao = this.detalhe.negocio.valor_negociacao;
    this.dataFechamentoEdicao = this.formatarDataInput(this.detalhe.negocio.data_fechamento_prevista);
    this.canalOrigemEdicao = this.detalhe.negocio.canal_origem || '';
    this.sellerResponsavelEdicao = this.detalhe.negocio.seller_id_responsavel;
    this.carregarSellersDetalhe(this.detalhe.negocio.departamento_id);
    this.buscaClienteDetalhe = this.detalhe.cliente ? this.detalhe.cliente.name : this.detalhe.negocio.cliente_nome;
    this.clienteDetalheEdicao = this.detalhe.cliente ? this.criarClienteEdicao(this.detalhe.cliente) : {
      client_id: this.detalhe.negocio.client_id
    };
    this.prepararFormularioDetalhe();
    this.limparAgendamentoClienteDetalhe();
  }

  private prepararFormularioDetalhe() {
    this.formularioValoresDetalhe = {};
    this.buscaProdutoDetalhe = {};
    this.produtosDetalhe = {};
    this.produtoSelecionadoDetalhe = {};

    (this.detalhe.formulario_campos || []).forEach(campo => {
      const valorSalvo = (this.detalhe.formulario_valores || []).find(valor => valor.campo_id === campo.id);

      if (valorSalvo) {
        if (campo.tipo === 'DECIMAL') {
          this.formularioValoresDetalhe[campo.id] = valorSalvo.valor_decimal;
        } else if (campo.tipo === 'INTEIRO' || campo.tipo === 'PRODUTO') {
          this.formularioValoresDetalhe[campo.id] = valorSalvo.valor_inteiro;
        } else if (campo.tipo === 'DATA') {
          this.formularioValoresDetalhe[campo.id] = this.formatarDataInput(valorSalvo.valor_data);
        } else if (campo.tipo === 'CADASTRO' || campo.chave === 'client_id') {
          this.formularioValoresDetalhe[campo.id] = valorSalvo.valor_client_id;
        } else if (campo.tipo === 'ARQUIVO') {
          this.formularioValoresDetalhe[campo.id] = valorSalvo.valor_arquivo_id;
        } else if (campo.tipo === 'ALTERNATIVA') {
          this.formularioValoresDetalhe[campo.id] = valorSalvo.valor_opcao_id;
        } else {
          this.formularioValoresDetalhe[campo.id] = valorSalvo.valor_texto;
        }
        return;
      }

      if (campo.chave === 'nome_negocio') {
        this.formularioValoresDetalhe[campo.id] = this.detalhe.negocio.nome_negocio;
      } else if (campo.chave === 'client_id') {
        this.formularioValoresDetalhe[campo.id] = this.detalhe.negocio.client_id;
      } else if (campo.chave === 'data_fechamento_prevista') {
        this.formularioValoresDetalhe[campo.id] = this.formatarDataInput(this.detalhe.negocio.data_fechamento_prevista);
      } else if (campo.chave === 'seller_id_responsavel') {
        this.formularioValoresDetalhe[campo.id] = this.detalhe.negocio.seller_id_responsavel;
      } else if (campo.chave === 'valor_negociacao') {
        this.formularioValoresDetalhe[campo.id] = this.detalhe.negocio.valor_negociacao;
      } else if (campo.chave === 'canal_origem') {
        this.formularioValoresDetalhe[campo.id] = this.detalhe.negocio.canal_origem;
      }
    });

    this.carregarProdutosSelecionadosDetalhe();
  }

  private carregarSellersDetalhe(departamentoId: number) {
    this.kanbanService.getSellers(departamentoId).subscribe(sellers => {
      this.sellersDetalhe = sellers || [];

      if (!this.sellerResponsavelEdicao && this.sellersDetalhe.length > 0) {
        this.sellerResponsavelEdicao = this.sellersDetalhe[0].id;
      }
    });
  }

  private criarClienteEdicao(cliente: KanbanClienteBusca): any {
    return {
      client_id: cliente.id,
      name: cliente.name,
      fantasia: cliente.fantasia,
      client_document: cliente.client_document,
      codigo_no_erp_do_cliente: cliente.codigo_no_erp_do_cliente,
      responsible_name: cliente.responsible_name,
      contato_callcenter: cliente.contato_callcenter,
      phone: cliente.phone,
      fone_02: cliente.fone_02,
      fone_03: cliente.fone_03,
      fone_whatss_ddd: cliente.fone_whatss_ddd,
      fone_whatss: cliente.fone_whatss
    };
  }

  private atualizarClienteDetalheLocal() {
    if (!this.detalhe || !this.detalhe.negocio || !this.clienteDetalheEdicao) {
      return;
    }

    this.detalhe.negocio.client_id = this.clienteDetalheEdicao.client_id;
    this.detalhe.negocio.cliente_nome = this.clienteDetalheEdicao.name || this.detalhe.negocio.cliente_nome;
    this.detalhe.negocio.cliente_fantasia = this.clienteDetalheEdicao.fantasia;
    this.detalhe.negocio.codigo_no_erp_do_cliente = this.clienteDetalheEdicao.codigo_no_erp_do_cliente;

    if (this.detalhe.cliente) {
      this.detalhe.cliente = Object.assign({}, this.detalhe.cliente, {
        id: this.clienteDetalheEdicao.client_id,
        name: this.clienteDetalheEdicao.name,
        fantasia: this.clienteDetalheEdicao.fantasia,
        client_document: this.clienteDetalheEdicao.client_document,
        codigo_no_erp_do_cliente: this.clienteDetalheEdicao.codigo_no_erp_do_cliente,
        responsible_name: this.clienteDetalheEdicao.responsible_name,
        contato_callcenter: this.clienteDetalheEdicao.contato_callcenter,
        phone: this.clienteDetalheEdicao.phone,
        fone_02: this.clienteDetalheEdicao.fone_02,
        fone_03: this.clienteDetalheEdicao.fone_03,
        fone_whatss_ddd: this.clienteDetalheEdicao.fone_whatss_ddd,
        fone_whatss: this.clienteDetalheEdicao.fone_whatss
      });
    }
  }

  private limparAgendamentoClienteDetalhe() {
    if (this.clienteDetalheSaveTimer) {
      clearTimeout(this.clienteDetalheSaveTimer);
      this.clienteDetalheSaveTimer = null;
    }
  }

  private formatarDataInput(data: any): string {
    if (!data) {
      return '';
    }

    const parsed = new Date(data);

    if (isNaN(parsed.getTime())) {
      return '';
    }

    const mes = ('0' + (parsed.getMonth() + 1)).slice(-2);
    const dia = ('0' + parsed.getDate()).slice(-2);
    return parsed.getFullYear() + '-' + mes + '-' + dia;
  }

  editarAnotacao(anotacao: any) {
    this.anotacaoEditandoId = anotacao.id;
    this.anotacaoEditandoTexto = anotacao.anotacao;
  }

  cancelarEdicaoAnotacao() {
    this.anotacaoEditandoId = null;
    this.anotacaoEditandoTexto = '';
  }

  salvarAnotacao(anotacao: any) {
    if (!this.anotacaoEditandoTexto || !this.anotacaoEditandoTexto.trim()) {
      this.toastr.warning('', 'Informe a anotacao.');
      return;
    }

    this.kanbanService.updateNote(anotacao.id, this.anotacaoEditandoTexto.trim()).subscribe(ok => {
      if (ok) {
        anotacao.anotacao = this.anotacaoEditandoTexto.trim();
        this.cancelarEdicaoAnotacao();
        this.toastr.success('', 'Anotacao atualizada.');
        this.carregar();
      }
    });
  }

  anexarArquivo(event: any) {
    const files = event.target.files;

    if (!files || files.length === 0 || !this.detalhe || !this.detalhe.negocio) {
      return;
    }

    this.kanbanService.uploadFile(this.detalhe.negocio.id, files[0]).subscribe(arquivo => {
      if (arquivo) {
        this.toastr.success('', 'Arquivo anexado com sucesso.');
        this.abrirDetalhe(this.detalhe.negocio);
      }
    });

    event.target.value = '';
  }

  selecionarArquivoNovo(event: any, campo: KanbanFormularioCampo) {
    const files = event.target.files;

    if (!files || files.length === 0 || !campo) {
      return;
    }

    this.arquivosPendentesNovo[campo.id] = files[0];
    this.formularioValoresNovo[campo.id] = null;
    event.target.value = '';
  }

  nomeArquivoPendenteNovo(campo: KanbanFormularioCampo): string {
    const arquivo = campo ? this.arquivosPendentesNovo[campo.id] : null;
    return arquivo ? arquivo.name : '';
  }

  abrirArquivoPendenteNovo(campo: KanbanFormularioCampo) {
    const arquivo = campo ? this.arquivosPendentesNovo[campo.id] : null;

    if (!arquivo) {
      return;
    }

    const url = window.URL.createObjectURL(arquivo);
    window.open(url, '_blank');
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  }

  removerArquivoNovo(campo: KanbanFormularioCampo) {
    if (!campo) {
      return;
    }

    delete this.arquivosPendentesNovo[campo.id];
    this.formularioValoresNovo[campo.id] = null;
  }

  arquivoCampoDetalhe(campo: KanbanFormularioCampo): KanbanArquivo {
    if (!campo || !this.detalhe || !this.detalhe.arquivos) {
      return null;
    }

    const arquivoId = Number(this.formularioValoresDetalhe[campo.id]);
    return this.detalhe.arquivos.find(arquivo => arquivo.id === arquivoId) || null;
  }

  anexarArquivoCampoDetalhe(event: any, campo: KanbanFormularioCampo) {
    const files = event.target.files;

    if (!files || files.length === 0 || !campo || !this.detalhe || !this.detalhe.negocio) {
      return;
    }

    this.kanbanService.uploadFile(this.detalhe.negocio.id, files[0]).subscribe(arquivo => {
      if (arquivo) {
        this.formularioValoresDetalhe[campo.id] = arquivo.id;
        this.salvarFormularioDetalhe();
      } else {
        this.toastr.error('', 'Nao foi possivel anexar o arquivo ao campo.');
      }
    });

    event.target.value = '';
  }

  excluirArquivoCampoDetalhe(campo: KanbanFormularioCampo) {
    const arquivo = this.arquivoCampoDetalhe(campo);

    if (!arquivo || !confirm('Deseja excluir este arquivo?')) {
      return;
    }

    this.kanbanService.deleteFile(arquivo.id).subscribe(excluido => {
      if (excluido) {
        this.formularioValoresDetalhe[campo.id] = null;
        this.toastr.success('', 'Arquivo excluido com sucesso.');
        this.abrirDetalhe(this.detalhe.negocio);
      } else {
        this.toastr.error('', 'Nao foi possivel excluir o arquivo.');
      }
    });
  }

  abrirArquivo(arquivo: KanbanArquivo) {
    if (!arquivo) {
      return;
    }

    this.kanbanService.openFile(arquivo.id).subscribe(blob => {
      if (!blob) {
        this.toastr.error('', 'Nao foi possivel abrir o arquivo.');
        return;
      }

      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
      setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    });
  }

  baixarArquivo(arquivo: KanbanArquivo) {
    if (!arquivo) {
      return;
    }

    this.kanbanService.openFile(arquivo.id).subscribe(blob => {
      if (!blob) {
        this.toastr.error('', 'Não foi possível baixar o arquivo.');
        return;
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = arquivo.nome_original || 'arquivo';
      document.body.appendChild(link);
      try {
        link.click();
      } finally {
        link.remove();
        setTimeout(() => window.URL.revokeObjectURL(url), 60000);
      }
    });
  }

  excluirArquivo(arquivo: KanbanArquivo) {
    if (!arquivo || !confirm('Deseja excluir este arquivo?')) {
      return;
    }

    this.kanbanService.deleteFile(arquivo.id).subscribe(excluido => {
      if (excluido) {
        this.toastr.success('', 'Arquivo excluido com sucesso.');
        this.abrirDetalhe(this.detalhe.negocio);
      } else {
        this.toastr.error('', 'Nao foi possivel excluir o arquivo.');
      }
    });
  }

  abrirLigacao() {
    if (!this.detalhe || !this.detalhe.negocio || !this.detalhe.cliente) {
      return;
    }

    if (this.detalhe.negocio.ligacao_agendada_id) {
      this.abrirLigacaoAgendadaNegocio(this.detalhe.negocio);
      return;
    }

    if (!this.detalhe.cliente.client_id_app) {
      this.toastr.warning('', 'Cliente sem codigo interno para iniciar a ligacao.');
      return;
    }

    const janelaLigacao = this.abrirPopup('about:blank', 'kanban_ligacao', 1200, 800);

    if (janelaLigacao == null) {
      this.toastr.warning('', 'O navegador bloqueou a janela da ligacao. Libere pop-ups para este portal.');
      return;
    }

    this.criarLigacaoKanban(janelaLigacao);
  }

  private criarLigacaoKanban(janelaLigacao: Window) {
    this.callCenterService.getTipo().subscribe(tipos => {
      const tipoRecebida = (tipos || []).find((tipo: CallCenterTipo) => tipo.id === 1) || (tipos || [])[0];

      if (!tipoRecebida) {
        this.fecharPopupEmBranco(janelaLigacao);
        this.toastr.error('', 'Nao foi possivel localizar o tipo da ligacao.');
        return;
      }

      const ligacao = new CallCenterLigacaoAnalitica();
      ligacao.client_id = this.detalhe.cliente.client_id_app;
      ligacao.seller_id = this.detalhe.cliente.seller_id || this.detalhe.negocio.seller_id_responsavel || parseInt(localStorage.getItem('id'), 10);
      ligacao.manual = true;
      ligacao.tmp = 1;
      ligacao.id_tmk = parseInt(localStorage.getItem('id'), 10);
      ligacao.tipo = tipoRecebida.id_tipo;
      ligacao.id_status = 5;
      ligacao.data_ligacao = new Date(this.datePipe.transform(Date.now(), 'yyyy/MM/dd HH:mm:ss', 'GMT-6'));

      this.callCenterService.addLigacao(ligacao).subscribe(adicionada => {
        if (!adicionada) {
          this.fecharPopupEmBranco(janelaLigacao);
          return;
        }

        this.callCenterService.getUltimaLigacaoByCliente(ligacao.client_id).subscribe(ligacaoCriada => {
          if (!ligacaoCriada || !ligacaoCriada.id) {
            this.fecharPopupEmBranco(janelaLigacao);
            this.toastr.error('', 'Nao foi possivel abrir a ligacao criada.');
            return;
          }

          this.criarVisitaKanban(janelaLigacao, ligacaoCriada, tipoRecebida);
        });
      });
    });
  }

  private criarVisitaKanban(janelaLigacao: Window, ligacao: CallCenterLigacaoAnalitica, tipo: CallCenterTipo) {
    this.visitaService.getProximoNumeroVisitaBySeller().subscribe(nroVisita => {
      if (!nroVisita || nroVisita <= 0) {
        this.abrirPopupLigacaoCriada(janelaLigacao, ligacao.id, null);
        return;
      }

      const visita = new Visita();
      visita.client_id = this.detalhe.cliente.client_id_app;
      visita.check_in_distance_in_meters = 0;
      visita.no_order_done_reason_id = null;
      visita.note = null;
      visita.is_active = true;
      visita.seller_id = parseInt(localStorage.getItem('id'), 10);
      visita.visit_id_app = nroVisita;
      visita.callcenter_tipo = tipo.id_tipo;
      visita.callcenter_status = 5;
      visita.id_call_center_ligacao = ligacao.id;

      this.visitaService.add(visita).subscribe(adicionada => {
        if (!adicionada) {
          this.abrirPopupLigacaoCriada(janelaLigacao, ligacao.id, null);
          return;
        }

        this.visitaService.getUltimaVisitaByCliente(visita.client_id).subscribe(visitaCriada => {
          this.abrirPopupLigacaoCriada(janelaLigacao, ligacao.id, visitaCriada && visitaCriada.id ? visitaCriada.id : null);
        });
      });
    });
  }

  private abrirPopupLigacaoCriada(janelaLigacao: Window, ligacaoId: number, visitaId: number) {
    let url = '/call-center-ligacao/' + ligacaoId + '?kanban_negocio=' + this.detalhe.negocio.id;

    if (visitaId) {
      url += '&visita=' + visitaId;
    }

    janelaLigacao.location.href = url;
    janelaLigacao.focus();
  }

  private fecharPopupEmBranco(janelaLigacao: Window) {
    if (janelaLigacao && janelaLigacao.location && janelaLigacao.location.href === 'about:blank') {
      janelaLigacao.close();
    }
  }

  abrirLigacaoAgendadaCard(evento: MouseEvent, negocio: KanbanNegocio) {
    if (evento) {
      evento.preventDefault();
      evento.stopPropagation();
    }

    this.abrirLigacaoAgendadaNegocio(negocio);
  }

  abrirLigacaoAgendada() {
    if (!this.detalhe || !this.detalhe.negocio) {
      return;
    }

    this.abrirLigacaoAgendadaNegocio(this.detalhe.negocio);
  }

  private abrirLigacaoAgendadaNegocio(negocio: KanbanNegocio) {
    if (!negocio || !negocio.ligacao_agendada_id) {
      return;
    }

    const url = '/call-center-ligacao/' + negocio.ligacao_agendada_id + '?kanban_negocio=' + negocio.id;
    this.abrirPopup(url, 'kanban_ligacao_agendada', 1200, 800);
  }

  abrirAnalise() {
    if (!this.detalhe || !this.detalhe.cliente || !this.detalhe.negocio) {
      return;
    }

    var url = '/call-center-ligacao?cliente_consulta=' + this.detalhe.cliente.id +
      '&kanban_negocio=' + this.detalhe.negocio.id;

    this.abrirPopup(url, 'kanban_analise', 1200, 800);
  }

  abrirPedido() {
    if (!this.detalhe || !this.detalhe.cliente || !this.detalhe.negocio) {
      return;
    }

    if (!this.detalhe.cliente.codigo_no_erp_do_cliente) {
      this.toastr.warning('', 'Cliente sem codigo ERP para abrir pedido.');
      return;
    }

    let urlPedido = this.router.serializeUrl(this.router.createUrlTree(['/pedidos-cadastro'], {
      queryParams: {
        cliente: this.detalhe.cliente.codigo_no_erp_do_cliente,
        kanban_negocio: this.detalhe.negocio.id,
        vendedor: this.detalhe.negocio.seller_id_responsavel || parseInt(localStorage.getItem('id'), 10),
        origem: 'kanban'
      }
    }));

    let janelaPedido = this.abrirPopup(urlPedido, 'kanban_pedido', 1200, 850);

    if (janelaPedido == null) {
      this.toastr.warning('', 'O navegador bloqueou a nova janela do pedido. Libere pop-ups para este portal.');
    }
  }

  abrirWhatsApp() {
    if (!this.detalhe || !this.detalhe.cliente) {
      return;
    }

    const telefone = (this.detalhe.cliente.fone_whatss_ddd || '') + (this.detalhe.cliente.fone_whatss || '');
    this.abrirPopup('/whatsapp-oficial?telefone=' + telefone + '&kanban_negocio=' + this.detalhe.negocio.id, 'kanban_whatsapp', 1200, 850);
  }

  private abrirPopup(url: string, nome: string, largura: number, altura: number): Window {
    const esquerda = Math.max(0, Math.floor((window.screen.width - largura) / 2));
    const topo = Math.max(0, Math.floor((window.screen.height - altura) / 2));
    const opcoes = 'popup=yes,width=' + largura + ',height=' + altura + ',left=' + esquerda + ',top=' + topo + ',resizable=yes,scrollbars=yes';
    const janela = window.open(url, nome, opcoes);

    if (janela != null) {
      janela.focus();
    }

    return janela;
  }

  etapasDepartamento(departamentoId: number): KanbanEtapa[] {
    const departamento = this.board.departamentos.find(d => d.id === departamentoId);
    return departamento ? departamento.etapas : [];
  }

  etapasFinalizacao(tipo: 'GANHO' | 'PERDA'): KanbanEtapa[] {
    if (!this.detalhe || !this.detalhe.negocio) {
      return [];
    }

    return this.etapasDepartamento(this.detalhe.negocio.departamento_id)
      .filter(etapa => etapa.tipo === tipo);
  }

  textoTipoEtapa(etapa: KanbanEtapa): string {
    if (!etapa || !etapa.tipo) {
      return '';
    }

    const tipo = etapa.tipo.toUpperCase();

    if (tipo === 'PIPELINE') {
      return 'ATENDIMENTO';
    }

    return tipo;
  }

  classeTipoEtapa(etapa: KanbanEtapa): string {
    const tipo = this.textoTipoEtapa(etapa);

    switch (tipo) {
      case 'ABERTO':
        return 'column-type-aberto';
      case 'ATENDIMENTO':
        return 'column-type-atendimento';
      case 'GANHO':
        return 'column-type-ganho';
      case 'PERDA':
        return 'column-type-perda';
      default:
        return 'column-type-default';
    }
  }

  classeBordaTipoEtapa(etapa: KanbanEtapa): string {
    const tipo = this.textoTipoEtapa(etapa);

    switch (tipo) {
      case 'ABERTO':
        return 'column-stage-aberto';
      case 'ATENDIMENTO':
        return 'column-stage-atendimento';
      case 'GANHO':
        return 'column-stage-ganho';
      case 'PERDA':
        return 'column-stage-perda';
      default:
        return 'column-stage-default';
    }
  }

  private primeiraEtapaAberta(): KanbanEtapa {
    if (!this.departamentoSelecionado || !this.departamentoSelecionado.etapas) {
      return null;
    }

    return this.departamentoSelecionado.etapas.find(e => e.tipo === 'ABERTO') || this.departamentoSelecionado.etapas[0];
  }
}
